/**
 * The local part is anything before the @ symbol
 * the host part is anything after the @ symbol.
 */

/**
 * https://www.braze.com/docs/user_guide/onboarding_with_braze/email_setup/email_validation/#microsoft-domains
 */
export const isValidLocalMicrosoft = (localPart: string): boolean => {
  const REGEX_LOCAL_MICROSOFT = /^\w[-\w]*(?:\.[-\w]+)*$/i;
  return REGEX_LOCAL_MICROSOFT.test(localPart);
};

/**
 * https://www.braze.com/docs/user_guide/onboarding_with_braze/email_setup/email_validation/#all-other-domains
 */
export const isValidLocalOthers = (localPart: string): boolean => {
  const REGEX_LOCAL_OTHERS =
    /^[a-zA-Z\d_-](?:[.+'a-zA-Z\d_&#/-]*[a-zA-Z\d_-])?$/;
  return REGEX_LOCAL_OTHERS.test(localPart);
};

/**
 * https://www.braze.com/docs/user_guide/onboarding_with_braze/email_setup/email_validation/#host-part-validation-rules
 */
export const isValidHostEmail = (hostPart: string): boolean => {
  const REGEX_HOST =
    /^[a-z\d](?:[a-z\d-]{0,61}[a-z\d])?(?:\.[a-z\d](?:[a-z\d-]{0,61}[a-z\d])?)+$/i;
  return REGEX_HOST.test(hostPart);
};

/**
 * https://www.braze.com/docs/user_guide/onboarding_with_braze/email_setup/email_validation/#microsoft-domains
 */
export const isMicrosoftDomain = (domainPart: string): boolean => {
  const REGEX_MICROSOFT_DOMAIN = /@(live|outlook|msn|hotmail)\.+/g;
  return REGEX_MICROSOFT_DOMAIN.test(domainPart);
};

/**
 * https://www.braze.com/docs/user_guide/onboarding_with_braze/email_setup/email_validation/#local-part-validation-rules
 */
const isValidLocalEmail = (localPart: string, hostPart: string): boolean => {
  if (isMicrosoftDomain(hostPart)) {
    return isValidLocalMicrosoft(localPart);
  }
  return isValidLocalOthers(localPart);
};

export const isValidEmailBraze = (email: string): boolean => {
  const emailParts = email.split('@');
  const localPart = emailParts[0];
  const hostPart = emailParts[1];
  return isValidLocalEmail(localPart, hostPart) && isValidHostEmail(hostPart);
};
